module.exports = __webpack_public_path__ + "static/img/qrocde.b3c1f6d1.jpg";